import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { carouselStyle } from "../Carousel/Carousel.css";

export const cardContainerStyle = style({
  selectors: {
    [`${carouselStyle} &`]: {
      width: rem(340),
      alignSelf: "stretch",
    },
  },
});

export const actionButtonStyle = style({
  pointerEvents: "none",
  justifySelf: "flex-end",
});

export const footerFlexStyle = style({
  gap: theme.spacings.xxs,
});
